// extracted by mini-css-extract-plugin
module.exports = {"Button":"Button_Button__2BYYQ","orange":"Button_orange__agFy0","borderless":"Button_borderless__22uks"};